import {
  Box,
  MenuItem,
  Popover,
  TextField,
  Typography,
} from "@mui/material";
import { CasLoader } from "../brand/CasLoader";
import { UseMenuProps } from "../../hook/menu";
import { Protocol } from "../../types/protocol";
import { useProtocolSearch } from "../../hook/protocol";

export const ProtocolSelectMenu: React.FC<
  UseMenuProps & {
    onChange: (component: Protocol) => Promise<any>;
  }
> = ({ onChange, ...useMenuProps }) => {
  const { onClose, open } = useMenuProps;
  const { searchString, setIsLoading, isLoading, setSearchString, page } =
    useProtocolSearch({ disabledSearch: !open });

  return (
    <Popover {...useMenuProps}>
      <Box sx={{ p: 2, width: "20rem" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h6">Select Protocol</Typography>
          {isLoading && <CasLoader size={20} />}
        </Box>
        <TextField
          fullWidth
          value={searchString}
          onChange={(e) => setSearchString(e.currentTarget.value)}
          placeholder="Search protocols..."
          sx={{ mt: 2 }}
        />
        <Box sx={{ height: "10rem", overflowY: "auto", mt: 1 }}>
          {page.map((proto) => {
            return (
              <MenuItem
                onClick={() => {
                  setIsLoading(true);
                  onChange(proto).then((comp) => {
                    setIsLoading(false);
                    onClose();
                  });
                }}
              >
                {proto.name}
              </MenuItem>
            );
          })}
        </Box>
      </Box>
    </Popover>
  );
};
